<FormInput
    v-model="filterValue"
    :attributes="{placeholder:'Поиск свойств'}"
    ref="variable-search-form-input"
/>
<FormCheckbox label="Показать удалённые свойства" v-model="showRemovedValue" class="mt-1" />
